export default function (value) {
  const date = new Date(value);

  if (isNaN(date)) return "NOT A DATE";

  return date.toLocaleString("ru-RU").split(",")[0];
}
